import PropTypes from "prop-types";
import SuccessIcon from "assets/svg/form-success.svg";

import styles from "./styles.module.css";

const CompanyDetailSuccessStep = ({ setCurrentStep }) => {
  const handleOk = () => {
    setCurrentStep("initial");
  };
  return (
    <div className={styles.successContainer}>
      <SuccessIcon className={styles.successIcon} />
      <p className={styles.successTitle}>Başvurunuzu Aldık</p>
      <p className={styles.successText}>Bilgilerinizi aldık, en kısa zamanda size ulaşacağız.</p>
      <button onClick={handleOk} className={styles.submitButton} type="button">
        Tamam
      </button>
    </div>
  );
};

CompanyDetailSuccessStep.propTypes = {
  setCurrentStep: PropTypes.object,
};

export default CompanyDetailSuccessStep;
